import React from 'react';
import { VStack } from '@chakra-ui/react';
import TablaOrdenes from './TablaOrdenes';
import OrdenesDesdeJuzgado from './OrdenesDesdeJuzgado';

const Ordenes: React.FC = () => (
  <VStack spacing={6} align="stretch" px={{ base: 2, md: 4 }} pt={79} pb={4}>
    <OrdenesDesdeJuzgado />
    <TablaOrdenes />
  </VStack>
);

export default Ordenes;
